<template>
  <FieldHeader :customer="customer" :field="field" v-if="field" >

    <v-row no-gutters v-masonry>

      <v-col cols="12" class="pa-1">
        <FieldBasics :field="field" />
      </v-col>

      <v-col cols="12" class="pa-1" v-if="edit">
        <v-textarea :label="$t('notes')" v-model="field.note" auto-grow outlined></v-textarea>
      </v-col>
      <v-col cols="12" class="pa-1" v-if="!edit && field.note">
        {{field.note}}
      </v-col>

      <v-col cols="12" class="pa-1" v-if="showLocation">
        <Map :locations="locations" />
      </v-col>

      <v-col cols="12" class="pa-1" v-if="showPlot">
        <MapPolygons :coords="coords" height='300px' />
      </v-col>

    </v-row>

    <v-row no-gutters v-if="images.length>0">
      <v-col cols="12" class="pa-1">
        <Images :images="images" />
      </v-col>
    </v-row>

  </FieldHeader>
</template>


<script>
  import fields from '@/mixins/fields';

  import Map from '@/components/Map';
  import TakePhoto from '@/components/TakePhoto';
  import Images from '@/components/Images';
  import Row from '@/components/Row';
  import LandSizeInput from '@/components/LandSizeInput';
  import MapPolygons from '@/components/MapPolygons';
  import FieldHeader from '@/views/fields/components/FieldHeader';
  import FieldBasics from '@/views/fields/components/Basics';

  export default {

    components: { Map, TakePhoto, Images, Row, LandSizeInput, MapPolygons, FieldHeader, FieldBasics },

    data: () => ({
      edit: false,
      field: undefined,
    }),

    computed: {
      customerUuid() { return this.$route.query.uuid; },
      fieldUuid() { return this.$route.query.fieldUuid; },
      customer() { return this.$store.getters.customer(this.customerUuid); },
      // field() { return this.customer.fields.filter( f => f.uuid==this.uuid )[0]; },
      images() { return this.$store.getters.images.filter( e => ( e.type_id==this.fieldUuid ) && (e.type==='field') ) ; },
      locations() { return (this.field.location ? [this.field.location] : []); },
      showPlot() { return this.field.map && this.field.map.length>2; },
      showLocation() { return !this.showPlot && this.locations.length>0; },
      crops() { return this.$store.getters.crops; },
      coords() {
        return [{
          customerUuid: this.customerUuid,
          fieldUuid: this.uuid,
          caption: this.field.name,
          coordinates: this.field.map,
        }];
      },
    },

    watch: {
      fieldUuid: {
        immediate: true,
        handler(to) {
          if (to && this.customer) {
            this.field = this.customer.fields.filter( f => f.uuid==to )[0];
          } else {
            this.field = undefined;
          }
        },
      }
    },

    methods: {
      updateFieldSize(size) {
        this.field.fieldSize.landSize = size.landSize;
        this.field.fieldSize.unit = size.unit;
      },
      toggleEdit() { this.edit = true; },
      upsert() {
        this.edit = false;
        // console.log(this.field);
        // console.log(this.deriveFieldName(this.field));
        this.field.name = this.deriveFieldName(this.field);
        this.$store.dispatch('upsertCustomer', this.customer);
      },
    },

    mixins: [fields],

  }
</script>


<i18n>
{
  "en": {
    "notes": "Notes"
  },
  "es": {
    "notes": "Notas"
  },
  "sw": {
    "notes": "Maelezo"
  }
}
</i18n>
